<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Enquiry Details</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="close()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="enquiryDetails" autocomplete="off">

    <div class="mb-3">
      <label class="form-label">Enquiry</label>
      <textarea class="form-control" 
                #enquiry
                formControlName="enquiry" 
                placeholder="Enquiry"
                maxlength="300"
                rows="4"></textarea>
      <div class="form-text text-end">{{enquiry.value?.length || 0}}/300</div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-6 col-form-label">Date Received</label>
      <div class="col-sm-6">
        <input type="date" 
               class="form-control" 
               [value]="enquiryDetails.value.receivedDate | date:'yyyy-MM-dd'"
               (change)="onDateReceivedChange($event)">
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-success" 
          (click)="save()">
    Save
  </button>
</div>